import { render, staticRenderFns } from "./MapContactsVue.vue?vue&type=template&id=5904cfc9&scoped=true"
import script from "./MapContactsVue.vue?vue&type=script&lang=js"
export * from "./MapContactsVue.vue?vue&type=script&lang=js"
import style0 from "./MapContactsVue.vue?vue&type=style&index=0&id=5904cfc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5904cfc9",
  null
  
)

export default component.exports